// useService.js
import React, { useEffect, useState } from 'react';
import { useForm } from '../forms/useForm';
import moment from 'moment';
import 'moment/locale/es';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from "../tokens/useToken";
import { useHistory } from "react-router-dom";

import { sendRequest } from "../../hooks/requests/useRequest";

export const useReportMicStatistics = () => {

    const [createSweet] = useSweetAlert();
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [listReport, setListReport] = useState([]);
    const [loadingReport, setLoadingReport] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const history = useHistory();

    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        start_date: "",
        end_date: "",
    });
    

    const { start_date, end_date } = formValues;

    const handleSearch = (e, search = true) => {
        if (e) e.preventDefault();

        if (search) {
            if (!start_date || !end_date) {
                createSweet("warning", "info", "Atención", "Debes seleccionar un rango de fechas.");
                return;
            }

            let query = "";
            const _from = start_date ? moment(start_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            const _to = end_date ? moment(end_date).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
            
            query += `from=${_from}&to=${_to}`;

            setIsDownloading(true);
            fetchReportMicrobiology(query);
        }
    };

    
    const fetchReportMicrobiology = async (_filter) => {
        try {
            await handleRequest( "POST", `Reports/ReportMicrobiologyStatistics?${_filter}`, "ReportMicrobiologyStatistics");

            createSweet( "success", "success", "Reporte", "El reporte se está generando."
            );

            await fetchListReportMicro();

            startPolling();

        } catch (err) {
            createSweet("error", "error", "Error", "No se pudo generar el reporte.");
        } finally {
            setIsDownloading(false);
        }
    };

    const fetchListReportMicro = async () => {
        try {
            const data = await handleRequest("GET", "Reports/ListReportMicrobiologyStatistics", "ListReportMicro");
            if (data && Array.isArray(data)) {
                setListReport(data);
                return data;
            } else {
                setListReport([]);
                return []; 
            }
        } catch (err) {
            // console.error("Error al listar lotes:", err);
            return [];
        }
    };

    const startPolling = () => {
        let interval = setInterval(async () => {
            const data = await fetchListReportMicro();

            const hasPending = data.some(
                r => r.progress === null || r.progress < 100
            );

            if (!hasPending) {
                clearInterval(interval);
            }
        }, 2500);
    };

    useEffect(() => {
        startPolling();
    }, []);

    
    //GLOBAL REQUEST
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }


    const handleDownloadReportMicro = async (row) => {
        try {
            if (!row || !row.download_filename) {
                createSweet( "warning", "warning", "Advertencia", "Archivo no disponible","No se encontró el reporte para descargar."
                );
                return;
            }
            setIsButtonDisabled(true);
            setLoadingReport(true);

            const token = localStorage.getItem("token");

            const response = await fetch(
                `/api/Reports/ReportMicrobiologyStatisticsDownload/${row.download_filename}`,
                {
                    method: "GET",
                    headers: new Headers({
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/vnd.ms-excel"
                })
                }
            );

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const fileName = row.download_filename.endsWith(".xlsx")
                ? row.download_filename
                : `${row.download_filename}.xlsx`;

            const a = document.createElement("a");
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();

            URL.revokeObjectURL(url);

            createSweet( "success", "success", "Éxito", "El reporte se descargó correctamente.");
        } catch (error) {
            console.error(error);
            createSweet( "error", "error", "Error", "Error al descargar el reporte", error.message);
        } finally {
            setIsButtonDisabled(false);
            setLoadingReport(false);
        }
    };


    


    return {
        start_date, end_date, handleInputChange, isDownloading, isButtonDisabled, handleSearch, listReport,
        handleDownloadReportMicro, searchTerm, setSearchTerm
      
    };
};
